import React from 'react';
import styled from 'styled-components';
import { BackLink } from '@sdir/blueprint.aps/lib/components';
import { IconWrapperSize, PageIcons } from './PageIcons';

type PageHeaderProps = {
  backText?: string;
  heading: string;
  primaryIcon?: any;
  secondaryIcon?: any;
  backClick?: () => void;
};

export const PageHeader: React.FC<PageHeaderProps> = ({
  backText,
  heading,
  primaryIcon,
  secondaryIcon,
  backClick,
}) => {
  return (
    <PageSubheader>
      <div>
        <PageIcons PrimaryIcon={primaryIcon} SecondaryIcon={secondaryIcon} color="#005c4f" />
        <Heading>{heading}</Heading>
      </div>
      {backClick && <BackLink text={backText || ''} onClick={backClick} />}
    </PageSubheader>
  );
};

const Heading = styled.h1`
  font-size: 32px;
  font-weight: 600;
  && {
    margin-bottom: 20px;
  }

  @media screen and (max-width: ${({ theme }) => theme.screen.medium}) {
    font-size: 28px;
  }
`;

const PageSubheader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  padding: 1em 0;
  margin-bottom: 3em;

  & > div {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: flex-end;
    order: 1;
    margin-left: calc(-${IconWrapperSize}px - 20px);

    @media screen and (max-width: ${({ theme }) => theme.screen.xLarge}) {
      margin-left: 0;
    }

    @media screen and (max-width: ${({ theme }) => theme.screen.medium}) {
      order: 2;
    }
  }

  & > button {
    order: 2;
    @media screen and (max-width: ${({ theme }) => theme.screen.medium}) {
      order: 1;
    }
  }

  @media screen and (max-width: ${({ theme }) => theme.screen.medium}) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
